<router-outlet></router-outlet>
<div id="logoutModal" class="modal">
    <div class="modal-content">
        <span class="close" id="closeModal">&times;</span>
        <p>Has sido desconectado debido a múltiples sesiones activas.</p>
        <button id="confirmLogout">Aceptar</button>
    </div>
</div>